import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import {useAuth} from './Auth/AuthContext';
import Chat from './Chat';
import Auth from './Auth/Auth';
import RecipeSearch from './RecipeDB/RecipeSearch';
import RecipeForm from './RecipeDB/RecipeForm';
import FavoriteRecipes from './RecipeDB/FavoriteRecipes';
import EditRecipe from './RecipeDB/EditRecipe';
import CommunityFeed from './Community/CommunityFeed';
import UserProfile from './Community/UserProfile';
import RecipeDetailPage from './Community/RecipeDetailPage';
import EditProfile from './Community/EditProfile';
import TermsAndConditions from './Legal/TermsAndConditions';
import PrivacyPolicy from './Legal/PrivacyPolicy';
import PricingPage from './Monetization/PricingPage';
import RecetarioPage from './RecipeDB/RecetarioPage';

// Ruta protegida: espera a que auth resuelva, luego redirige a login si no hay sesión
const ProtectedRoute = ({children}) => {
    const {isAuthenticated, authLoading} = useAuth();
    if (authLoading) return null;
    return isAuthenticated ? children : <Navigate to="/" replace />;
};

// Ruta solo para no autenticados: si ya hay sesión va a /community
const AuthRoute = ({children}) => {
    const {isAuthenticated, authLoading} = useAuth();
    if (authLoading) return null;
    return !isAuthenticated ? children : <Navigate to="/community" replace />;
};

const AppRoutes = ({userId}) => (
    <Routes>
        {/* ── Siempre públicas ─────────────────────────────────────── */}
        <Route path="/terminos"   element={<TermsAndConditions />} />
        <Route path="/privacidad" element={<PrivacyPolicy />} />
        <Route path="/pricing"    element={<PricingPage />} />

        {/* ── Solo para no autenticados ────────────────────────────── */}
        <Route path="/" element={<AuthRoute><Auth /></AuthRoute>} />

        {/* ── Protegidas ───────────────────────────────────────────── */}
        <Route path="/community"
            element={<ProtectedRoute><CommunityFeed userId={userId} /></ProtectedRoute>} />
        <Route path="/chat"
            element={<ProtectedRoute><Chat userId={userId} /></ProtectedRoute>} />
        <Route path="/search"
            element={<ProtectedRoute><RecipeSearch userId={userId} /></ProtectedRoute>} />
        <Route path="/favorite-recipes"
            element={<ProtectedRoute><FavoriteRecipes userId={userId} /></ProtectedRoute>} />
        <Route path="/profile/:userId"
            element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/profile"
            element={<ProtectedRoute><Navigate to={`/profile/${userId}`} replace /></ProtectedRoute>} />
        <Route path="/recipe/:recipeId"
            element={<ProtectedRoute><RecipeDetailPage /></ProtectedRoute>} />
        <Route path="/add-recipe"
            element={<ProtectedRoute><RecipeForm /></ProtectedRoute>} />
        <Route path="/profile/edit"
            element={<ProtectedRoute><EditProfile /></ProtectedRoute>} />
        <Route path="/edit-recipe/:recipeId"
            element={<ProtectedRoute><EditRecipe /></ProtectedRoute>} />
        <Route path="/recetario/:recetarioId"
            element={<ProtectedRoute><RecetarioPage /></ProtectedRoute>} />

        {/* ── Wildcard: sin sesión → login, con sesión → community ─── */}
        <Route path="*"
            element={<ProtectedRoute><Navigate to="/community" replace /></ProtectedRoute>} />
    </Routes>
);

export default AppRoutes;